import { lessonDetailsActionTypes } from './Constants';

const initialState = {
	loading: true,
	data: {},
	scheduledLessons: [],
	loadingScheduledLessons: true,
	topics: {},
	loadingTopics: true,
	error: {},
};

export default function lessonDetailsReducer(state = initialState, action) {
	const { type, payload } = action;

	const { data, topics, signedUp } = payload || {};

	switch (type) {
		case lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
				loadingTopics: true,
			};

		case lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_SUCCESS:
			return {
				...state,
				data,
				loading: false,
				loadingTopics: false,
				topics,
			};

		case lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_ERROR:
			return {
				...state,
				loading: false,
				loadingScheduledLessons: false,
				loadingTopics: false,
			};

		case lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_REQUEST:
			return {
				...state,
				loadingScheduledLessons: true,
			};

		case lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_SUCCESS:
			return {
				...state,
				scheduledLessons: data,
				loadingScheduledLessons: false,
			};

		case lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_ERROR:
			return {
				...state,
				loadingScheduledLessons: false,
			};

		case lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_REQUEST:
			return {
				...state,
				loadingScheduledLessons: true,
			};

		case lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_SUCCESS:
		case lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_ERROR:
			return {
				...state,
				loadingScheduledLessons: false,
			};

		case lessonDetailsActionTypes.SET_LESSON_SIGNED_UP:
			return {
				...state,
				signedUp,
			};

		case lessonDetailsActionTypes.CLEAR_LESSON_DETAILS_DATA:
			return {
				...state,
				data: {},
				scheduledLessons: [],
			};
		default:
			return state;
	}
}
